import React, { FC } from 'react';
import { capitalize } from 'lodash';
import { Box, Divider, ProgressList, SentimentBar } from '@scope/scope-one-ui/core';
import { RadioIcon } from '@scope/scope-one-ui/core/Radio/Radio.styled';
import RadioOff from '../../../../assets/icons/radio-button-off.svg';
import { EsgEventsCardProps } from './EsgEventsCard.d';
import { RadioWidget, WidgetContent } from './EsgEventsCard.styled';

export const EsgEventsCard: FC<EsgEventsCardProps> = ({
  eventsList,
  activeType,
  type,
  loading,
  filter,
  onPick,
  onFilter,
}) => {
  const data = (eventsList?.events || [])
    .map((item) => {
      const { value } = item.attentionBuzz;
      return {
      label: item.eventInfo.name,
      count: filter === 'max' ? 0 : value,
      tooltip: `Attention Buzz: ${
        filter === 'max' || !value ? 'n/a' : `${value.toFixed(2) }%`
      }`
    }})
    .sort((a, b) => b.count - a.count);

  const total = Math.max(...data.map((item) => item.count));

  const { negative, neutral, positive } = eventsList?.count || {
    negative: 0,
    neutral: 0,
    positive: 0,
  };

  const select = () => onPick(type);

  return (
    <Box display="flex" flexDirection="column" flex={1} onClick={select}>
      <RadioWidget
        active={activeType === type}
        title={capitalize(type)}
        customHeader={
          <RadioIcon active={activeType === type}>
            <RadioOff />
            <RadioOff />
          </RadioIcon>
        }
      >
        <WidgetContent display="flex" flex={1} flexDirection="column">
          <Box flex={1} p={1}>
            <ProgressList hideCount data={data} total={total} loading={loading} />
          </Box>
          <Divider />
          <Box p={3}>
            <SentimentBar
              period={filter}
              onPeriodChange={(val) => onFilter(type, val)}
              negative={negative}
              neutral={neutral}
              positive={positive}
              loading={loading}
            />
          </Box>
        </WidgetContent>
      </RadioWidget>
    </Box>
  );
};
